import React, { useState } from 'react';
import './Admin.css';

const AdminLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Dummy authentication
    if (credentials.username === 'AdmingainWisdom' && credentials.password === 'gainWisdom@123') {
      onLogin();
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div className="admin-login">
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" placeholder="Username" onChange={(e) => setCredentials({ ...credentials, username: e.target.value })} required />
        <input type="password" placeholder="Password" onChange={(e) => setCredentials({ ...credentials, password: e.target.value })} required />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default AdminLogin;
